import { useGetAiAgentProfilesForPortalQuery } from '../../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';
export const useHasCustomerAgent = () => {
  var _data$results;
  const {
    data,
    loading: loadingCustomerAgent
  } = useGetAiAgentProfilesForPortalQuery({
    variables: {
      pageLength: 1
    }
  });
  const hasCustomerAgent = data === null || data === void 0 || (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.some(profile => !profile.isPreview);
  return Boolean(!loadingCustomerAgent && hasCustomerAgent);
};